module.exports = __webpack_public_path__ + "static/img/vue-fire.b4c4338.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vue-fire.png
// module id = l6Eb
// module chunks = 1